<template>
  <div class="card">
    <div class="card-image">
      <b-image
        responsive
        :src="instance.picture"
        :alt="instance.fullName"
        ratio="1by1"
      />
    </div>
    <div class="card-content p-4">
      <div class="media mb-2">
        <div class="media-content">
          <p class="title is-5">
            <router-link :to="instance.url">
              {{ instance.fullName }}
            </router-link>
          </p>
        </div>
      </div>

      <div class="content">
        {{ instance.summary }}
        <router-link :to="instance.url">[...]</router-link>

        <br />
      </div>
      <!-- div class="card-footer">
        <time :datetime="instance.kidnapping.fechades">{{ instance.kidnapping.fechades | formatDate }}</time> | 
        <strong>{{ instance.kidnapping.edad }} años</strong>
      </div -->
    </div>
  </div>
</template>
<script>
export default {
  props: ["instance"],
};
</script>
